import Swiper from 'swiper';

export default function() {

    let videosSliders = document.getElementsByClassName('js-videos-slider');

    Array.from(videosSliders).forEach(function (slider) {

        let videosSwiper = new Swiper(slider, {
            loop: false,
            speed: 600,
            spaceBetween: 20,
            slidesPerView: 'auto',
            navigation: {
                nextEl: slider.parentElement.getElementsByClassName('videos-slider__arrow-next')[0],
                prevEl: slider.parentElement.getElementsByClassName('videos-slider__arrow-prev')[0]
            },
            breakpoints: {
                765: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
                980: {
                    spaceBetween: 20,
                    slidesPerView: 3,
                },
                1170: {
                    spaceBetween: 30,
                    slidesPerView: 4,
                }
            }
        });
    });

    let firstPic = document.querySelector('.videos-slider__item .video-link__pic');
    if(firstPic) {
        let navArrowLeft = document.getElementsByClassName('videos-slider__arrow-prev')[0];
        let navArrowRight = document.getElementsByClassName('videos-slider__arrow-next')[0];

        function countArrow() {
            let arrowHeight = firstPic.clientHeight;
            navArrowLeft.style.height = arrowHeight + 'px';
            navArrowRight.style.height = arrowHeight + 'px';
        }

        countArrow();

        window.addEventListener('resize', countArrow);
        window.addEventListener('load', countArrow);
    }


}

